import {ComponentService} from "./service/component";
import {Application} from "./application/application";
import {FormContactComponent} from "./components/form-contact";

require("@babel/polyfill");
require('picturefill/dist/picturefill.js');

(($) => $(() => {
    let components = new ComponentService();
    // components.addComponent('.js-location-map', LocatioMapComponent, 'FormContactComponent');
    new Application(components);
}))(jQuery);
